var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 35,
    viewBox: "0 0 24 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6047 19.2805C23.6047 27.9142 18.8505 35 10.3484 35C1.84636 35 -2.08798e-05 29.1812 1.7709e-10 25.1862C1.7709e-10 16.5525 10.3484 11 12.3154 0.0870731C14.7101 -1.12879 23.6047 10.6468 23.6047 19.2805Z",
    fill: "#F7C176"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6511 26.8748C17.6511 30.2752 14.0345 33 10.4538 33C6.87317 33 4.65111 29.1235 4.65112 27.55C4.65115 22.5854 10.4538 23.3847 12.2345 18.9884C13.6521 15.4881 17.6511 22.0392 17.6511 26.8748Z",
    fill: "#95503D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/flame.349953a1971130f53ada6f88927321c1.svg";
export { ForwardRef as ReactComponent };